import styled from 'styled-components';

import { Portal } from '@dreryk/react-components';

const FORMS_TEMPLATES_PORTAL_ID = 'visitFormsTemplatesPortal';
const FORMS_TEMPLATES_ROOT_PORTAL_ID = 'visitFormsTemplatesRootPortal';

export const FormsTemplatesPortalContainer = (): JSX.Element => {
   return <Portal.Container testId={'formsTemplates'} id={FORMS_TEMPLATES_PORTAL_ID} />;
};

type FormsTemplatesPortalProps = {
   readonly children: JSX.Element;
};

export const FormsTemplatesPortal = (props: FormsTemplatesPortalProps): JSX.Element => {
   return <Portal containerId={FORMS_TEMPLATES_PORTAL_ID}>{props.children}</Portal>;
};

const StyledFormsTemplatesRootPortalContainer = styled(Portal.Container)`
   &:not(:empty) ~ * {
      display: none;
   }
`;

export const FormsTemplatesRootPortalContainer = (): JSX.Element => {
   return <StyledFormsTemplatesRootPortalContainer testId={'formsTemplatesRoot'} id={FORMS_TEMPLATES_ROOT_PORTAL_ID} />;
};

export const FormsTemplatesRootPortal = (props: FormsTemplatesPortalProps): JSX.Element => {
   return <Portal containerId={FORMS_TEMPLATES_ROOT_PORTAL_ID}>{props.children}</Portal>;
};
